import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types'
import { toastr } from 'react-redux-toastr'
import { connect } from 'react-redux'
import _ from 'lodash'
import Toggle from 'react-toggle'
import { useTranslation } from 'react-i18next'

import GreyHeader from '../../dump/menuComponents/GreyHeader'
import IconTooltip from '../../dump/menuComponents/IconTooltip'
import FleetDriverIdModal from './FleetDriverIdModal'
import CustomButton from '../../CustomButton'
import EventVideoExpiration from '../../common/EventVideoExpiration'
import { getCompanyById, updateCompany } from '../../../action/CompaniesActions'

const AccountFleetSettings = (props) => {
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'accountPage.accountFleetSettings' });
	const { toggleLoader, user, company } = props;
	const userRole = user.roles[0];
	const [companyData, setCompanyData] = useState({});
	const [data, setData] = useState({
		event_expiration: '365',
		speedlimit_feature: false,
		speedlimit_audio: false,
	});
	const [showFleetDriverIDModal, setShowFleetDriverIDModal] = useState(false);
	const [upd, setUpd] = useState(false);

	useEffect(() => {
		getCompany();
	}, []);

	useEffect(() => {
		getCompany();
	}, [company.company_id]);

	const getCompany = () => {
		toggleLoader(true);
		if (company && company.company_id) {
			getCompanyById(user.roles[0], company.company_id)
				.then((res) => {
					console.log('!getCompany res: ', res)
					toggleLoader(false);
					const companyData = res.data.response.company;
					setCompanyData(companyData);
					setData({
						event_expiration: companyData.event_expiration || '365',
						speedlimit_feature: companyData.speedlimit_feature || false,
						speedlimit_audio: companyData.speedlimit_audio || false
					});
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!getCompany error: ', error.response, error)

					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
	};

	const fillForm = (e) => {
		const { target } = e
		const value = target.type === 'checkbox' ? target.checked : target.value
		const { name } = target

		let UpdateData = data
		UpdateData[name] = value
		setData(UpdateData);
		setUpd(!upd);
	};

	const checkForm = (data) => {
		let error = false;
		let errMessage = ''

		for (let i in data) {
			if (data[i] === null) {
				error = true;
				errMessage = t('errEnterYour') + i + '!'
			} else if (errMessage[i]) {
				errMessage = null
			}
		}

		if (errMessage) {
			toastr.error(errMessage)
		}
		return error;
	};

	const sendForm = (e) => {
		e.preventDefault();

		const changedData = _.reduce(_.keys(data), (result, key) => {
			if (!Object.prototype.hasOwnProperty.call(companyData, key) || !_.isEqual(companyData[key], data[key])) {
				result[key] = data[key]
			}
			return result;
		}, {});
		if (_.isEmpty(changedData)) {
			toastr.warning('', t('fleetSettingsChanges'))
			return
		}

		const params = {
			company: companyData,
			data: changedData,
		}

		const error = checkForm(changedData)
		if (!error) {
			toggleLoader(true);
			updateCompany(params, userRole)
				.then((res) => {
					console.log('!AccountFleetSettings updateCompany res: ', res)
					toggleLoader(false);

					setCompanyData(res.data.response.company);
					toastr.success('', t('fleetSettingsChanged'));
				})
				.catch((error) => {
					toggleLoader(false);
					console.log('!AccountFleetSettings updateCompany error: ', error.response, error)

					let errDescription = i18n.t('errorMessage.errDescription');
					if (error.response.data.response.error) {
						errDescription = error.response.data.response.error
					}
					toastr.error(errDescription)
				})
		}
	};

	const showFleetDriverModal = () => {
		setShowFleetDriverIDModal(true);
	};
	const isDisabled = () => ((data.event_expiration === companyData.event_expiration) && (data.speedlimit_feature === companyData.speedlimit_feature) && (data.speedlimit_audio === companyData.speedlimit_audio));
	const driverIdEnabled = props.company.driver_recognition === "cardreader";
	const env = location.hostname

	return (
		<div className="account-settings">
			<GreyHeader title={t('titleFleetSettings')} />

			<div className="page-subheader">
				<CustomButton
					disabled={isDisabled()}
					variant="secondary"
					onClick={sendForm}
				>
					{t('btnSaveChanges')}
				</CustomButton>
			</div>

			<main className="main-content-block">
				<div className="wrapper-user-settings">
					<EventVideoExpiration
						companyId={company.company_id}
						value={data.event_expiration}
						className="fleet-settings"
						onChange={(value) => fillForm({target: { name: 'event_expiration', value }})}
					/>

					<div className="toggle-wrapper">
						<IconTooltip
							description={t('descriptionDriverID')}
						/>
						<label className="user-settings-label">{t('labelDriverID')}</label>
						<Toggle
							checked={driverIdEnabled}
							onChange={showFleetDriverModal}
						/>
					</div>
				</div>

				{/* {['system_admin', 'customer_service', 'partner', 'fleet_manager'].includes(userRole) && ( */}
				{/* {['system_admin', 'customer_service'].includes(userRole) && ( */}
				{/* FWSD-8270, Hide the SpeedLimit feature (and toggle to enable this feature) from Geotab related companies and all of Tenna companies */}
				{(!companyData?.geotab_database && (
					(env === 'fleet.roscolive.com' && +companyData?.created_by_company_id !== 2171)
					|| (env !== 'fleet.roscolive.com' && +companyData?.created_by_company_id !== 7921)
				)) && (
						<div>
							<div className="wrapper-speeding">
								<div className="cardHeader">
									<div className="card-header-speeding">
										{t('headerSpeedLimits')}
									</div>
									<div className="toggle-wrapper-speeding">
										<Toggle
											checked={data.speedlimit_feature}
											name="speedlimit_feature"
											onChange={fillForm}
										/>
									</div>
								</div>
								<div className="card-body">
									<p>{t('bodySpeeding')}</p>
									<ul>
										<li>{t('textLowSpeeding')}</li>
										<li>{t('textModerateSpeeding')}</li>
										<li>{t('textHighSpeeding')}</li>
										<li>{t('textSevereSpeeding')}</li>
									</ul>
									<p>
										{t('textSpeeding')} <Link to='/account/settings'>{t('linkSpeeding')}</Link>
									</p>
								</div>
							</div>
							{data.speedlimit_feature && (
								<>
									<div className="wrapper-eventAudio">
										<div className="card-header-eventAudio">
											{t('headerEventAudio')}
										</div>
										<div className="toggle-eventAudio">
											<Toggle
												checked={data.speedlimit_audio}
												name="speedlimit_audio"
												onChange={fillForm}
											/>
										</div>
									</div>
									<div className="card-body">
										<p>{t('textEventAudio')}</p>
									</div>
								</>)}
						</div>)}
			</main>
			{showFleetDriverIDModal &&
				<FleetDriverIdModal
					driverIdEnabled={driverIdEnabled}
					onHide={() => setShowFleetDriverIDModal(false)}
				/>
			}
		</div>
	)
}

AccountFleetSettings.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(({ user, company }) => ({
	user: user.user,
	company: company.company
}),
	dispatch => ({
		updateUser: (user) => {
			dispatch({ type: 'GET_USER_SUCCESS', payload: user });
		},
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	}))(AccountFleetSettings);
